import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/cansibei', label: '蚕丝被护理' },
    { to: '/category/yurongbei', label: '羽绒被干洗' },
    { to: '/category/meinvbei', label: '美女被干洗' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="container-main flex items-center justify-between py-4">
        <Link to="/" className="flex items-center gap-2 no-underline">
          <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
            <i className="ri-shirt-line text-lg"></i>
          </span>
          <span className="text-xl font-bold text-foreground-900 font-heading whitespace-nowrap">
            被护专家
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="px-4 py-2 text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-md transition-colors duration-200 whitespace-nowrap no-underline"
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:4008886666"
            className="flex items-center gap-1.5 text-sm text-primary-600 font-medium whitespace-nowrap no-underline hover:text-primary-700"
          >
            <i className="ri-phone-line"></i>
            <span>400-888-6666</span>
          </a>
        </div>

        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-700 rounded-md hover:bg-background-100 transition-colors"
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg">
          <div className="container-main py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMobileMenuOpen(false)}
                className="px-4 py-3 text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-md transition-colors no-underline"
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:4008886666"
              className="px-4 py-3 text-sm text-primary-600 font-medium flex items-center gap-2 no-underline hover:text-primary-700"
            >
              <i className="ri-phone-line"></i>
              400-888-6666
            </a>
          </div>
        </div>
      )}
    </header>
  );
}